var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tagWrap",style:(("width:" + _vm.width + ";height:" + _vm.height))},[_c('i',{class:("iconfont " + _vm.icon)}),_c('span',[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }